import { AfterViewChecked, AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UserService } from './services/user.service';
import { User } from './models/user';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Domain } from './models/domain';
import { DomainService } from './services/domain.service';
import { MenuService } from './services/menu.service';
import { WsbFrontendService } from './views/wsb-frontend/wsb-frontend.service';
import { BrandName, decodeLanguage } from './utils/utils';
import { NavigationEnd, NavigationStart, Router, RouterStateSnapshot } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { ROLE_ADMIN_ID, ROLE_OWNER_ID } from './models/role';
import $ from 'jquery';
import { LoginService } from './core/login/login.service';
import { ApiMDelegatedService } from '@services/api-m-delegated.service';
import { environment } from '../environments/environment';
import * as _ from 'lodash';
import { LoaderService } from '@services/loader.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, Validators } from '@angular/forms';
import { checkIfEmailAreEquals } from '@utils/validators';
import { ProfileService } from '@services/profile.service';
import { AtlasToastService } from '@services/atlas-toast.service';
import { ToastContainerDirective } from 'ngx-toastr';
@Component({
  selector: 'wsb-ui-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
  @ViewChild('navSidebarMenu', { static: true }) $navSidebarMenu;

  @ViewChild('childLinkSMS5', { static: false }) childLinkSMS5;
  @ViewChild('childLinkSUBACCOUNT3', { static: false }) childLinkSUBACCOUNT3;
  @ViewChild('childLinkSUBACCOUNT6', { static: false }) childLinkSUBACCOUNT6;
  @ViewChild('modalRegistrationEmail') modalRegistrationEmail;
  @ViewChild('modalExpirePWD') modalExpirePWD;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  modalExpirePWDRef: NgbModalRef;
  modalRegistrationEmailModal: NgbModalRef = null;

  isSidebarFull = true;
  isFullScreen = true;
  title = 'frontend';
  user: User | null;
  domain: Domain | null;
  canShopping = false;
  initCanShopping = false;
  private userSubscription: Subscription;
  private domainSubscription: Subscription;
  private menuEntriesSubscription: Subscription;
  menuEntries = {};
  allowProfileManageAndShopAndBilling: any;
  urlRcp: string;
  sendSmsPage: string;

  addEmailRegistration = new UntypedFormControl('', [Validators.required, Validators.email]);
  repeatEmailRegistration = new UntypedFormControl('');

  constructor(
    private translate: TranslateService,
    private userService: UserService,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title,
    private domainService: DomainService,
    private menuService: MenuService,
    private sessionStorage: SessionStorageService,
    private profileService: ProfileService,
    private router: Router,
    private loginService: LoginService,
    private modalService: NgbModal,
    private apiMDelegatedService: ApiMDelegatedService,
    private atlasToastService: AtlasToastService,
    private loaderService: LoaderService,
    /* php-integration-block */
    private wsbFrontendService: WsbFrontendService /* php-integration-block-end */
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.repeatEmailValidator();

    this.checkReturnUrl();
    this.checkApiMDelegation();
    this.domainSubscription = this.domainService.getDomainState().subscribe(domain => {
      this.sessionStorage.store('wsb-brand-name', domain.brand.systemId.toLowerCase());
      this.sessionStorage.store('wsb-require-cig-code', domain.requireCigCodeOnSuperSubTransfers === true);
      this.domain = domain;
      // this.domain.shopUrl = "https://www.google.com/" ;
      const logo32x32 = this.document.getElementById('favicon32x32');
      const logo16x16 = this.document.getElementById('favicon16x16');
      const appleTouchIcon = this.document.getElementById('apple-touch-icon');
      logo32x32.setAttribute('href', this.domain.faviconUrl);
      logo16x16.setAttribute('href', this.domain.faviconUrl);
      appleTouchIcon.setAttribute('href', this.domain.faviconUrl);
      if (!(window as any).loadedSeoHtml) {
        (window as any).loadedSeoHtml = true;
        if (this.domain.seoHtml) {
          const scriptEl = document.createRange().createContextualFragment(this.domain.seoHtml);
          document.head.append(scriptEl);
        }
      }
      this.personalizeStyle(domain);
    });

    this.userSubscription = this.userService.getAuthenticationState().subscribe(loggedUser => {
      this.user = loggedUser;
      if (!_.isNull(loggedUser) && loggedUser.account && !this.initCanShopping) {
        this.canShopping = this.user.account.isCustomer;
        this.initCanShopping = true;
      }
      if (loggedUser) {
        if (loggedUser.account?.isUpgraded && loggedUser.account?.titanLoginRedirectUrl?.length) {
          window.location.href = loggedUser.account.titanLoginRedirectUrl;
        }
        this.translate.use(loggedUser.preferences.language.substring(0, 2));
        this.loginService.getTokenExchange().subscribe(
          tokenExchange => {
            // Redirect to studio or other services if logged
            if (!this.userService.checkRedirectToReturnUrl(tokenExchange)) {
              this.userService.checkRedirectApiMDelegation();
            }
          },
          error => {
            console.error('Error during token exchange', error);
          }
        );
        // if (!this.userService.checkRedirectToReturnUrl()) {
        //   this.userService.checkRedirectApiMDelegation();
        // }
        // check if open modal registratio email
        if (loggedUser.profile.registrationEmail === null) {
          if (this.modalRegistrationEmailModal === null) {
            this.sessionStorage.store('wsb-routing-allowed', false);

            setTimeout(() => {
              this.openRegistrationEmailModal();
            }, 1000);
          }
        } else {
          this.sessionStorage.store('wsb-routing-allowed', true);
        }
      }
      this.allowProfileManageAndShopAndBilling =
        this.sessionStorage.retrieve('wsb-userprofile-role') === ROLE_OWNER_ID ||
        this.sessionStorage.retrieve('wsb-userprofile-role') === ROLE_ADMIN_ID;

      if (this.user) {
        this.sendSmsPage = this.user.account.canSendOnlyToRegistrationNumber ? '/sms/sendTrial' : '/sms/send';
        if (this.loginService.isUniversalLogin() && this.user?.profile?.resetPassword) {
          this.openModalExpirePWD();
        }
      }
    });

    combineLatest([this.wsbFrontendService.wsbRouter, this.userService.getAuthenticationState()]).subscribe(([wsbUrl, loggedUser]: any) => {
      this.isFullScreen =
        loggedUser === null ||
        wsbUrl === '/login' ||
        wsbUrl === '/loginfastsms' ||
        wsbUrl.startsWith('/registration/') ||
        wsbUrl.startsWith('/register') ||
        wsbUrl.includes('/mail/compose') ||
        wsbUrl.includes('/mail/mail-editor') ||
        wsbUrl.includes('/pages/compose') ||
        wsbUrl.includes('/pages/compose2') ||
        wsbUrl.includes('/mail/mail-editor2');
    });
    /* php-integration-block-end */

    this.menuEntriesSubscription = this.menuService.getMenuEntriesState().subscribe(entries => (this.menuEntries = entries));
    this.translate.onLangChange.pipe(switchMap(() => this.translate.get('page_title'))).subscribe(pageTitle => {
      if (pageTitle !== 'page_title') {
        this.titleService.setTitle(pageTitle);
      } else {
        this.titleService.setTitle('Login');
      }
    });
    this.translate.onLangChange.pipe(switchMap(() => this.translate.get('url_rcp'))).subscribe(urlRcp => {
      this.urlRcp = urlRcp;
    });

    if (!this.user) {
      this.translate.use(decodeLanguage(this.translate.getBrowserLang()));
    }

    // Analytics && shop billing details
    // this.router.navigate(['shop/cart-billing']);

    this.userService.updateBillingDetails.subscribe(res => {
      if (res) {
        this.canShopping = true;
        this.router.navigate(['shop/cart-summary']);
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (!this.isFullScreen) {
          this.closeMobileNav();
        }
        if (event.url === '/shop/cart-summary' && !this.canShopping) {
          this.router.navigate(['shop/cart-billing']);
        }
      }
      if (event instanceof NavigationEnd && (window as any).gtagConfig) {
        const path = event.urlAfterRedirects;
        (window as any).gtagConfig({ page_path: path });
        //ga4
        if ((window as any).gtagEvent) {
          (window as any).gtagEvent('page_view', { page_location: location.origin + path });
        }
      }
    });
  }

  repeatEmailValidator() {
    this.addEmailRegistration.valueChanges.pipe(debounceTime(200)).subscribe(email => {
      this.repeatEmailRegistration.setValidators(checkIfEmailAreEquals(email));
      this.repeatEmailRegistration.updateValueAndValidity();
    });
  }

  get userLogin() {
    if (this.user) {
      return this.user.login;
    }
    return null;
  }

  get userIdKey() {
    return this.sessionStorage.retrieve('wsb-user-key');
  }

  get areEmailsEquals() {
    return this.addEmailRegistration.value === this.repeatEmailRegistration.value;
  }

  ngAfterViewChecked(): void {
    this.processSubmenusHeight();
    this.bindMenuItemsClick();
  }

  ngAfterViewInit(): void {
    /* php-integration-block */
    // Attempt automatic login
    setTimeout(() => {
      if (
        this.router.url.split('?')[0] !== '/reset/profile' &&
        this.router.url.split('?')[0] !== '/reset/password' &&
        this.router.url.split('?')[0] !== '/reset/email' &&
        this.router.url.split('?')[0] !== '/register' &&
        window.location.pathname !== '/external-auth'
      ) {
        if (
          this.router.url.split('?')[0] !== '/login' &&
          this.router.url.split('?')[0] !== '/loginfastsms' &&
          this.sessionStorage.retrieve('wsb-user-status') &&
          this.sessionStorage.retrieve('wsb-user-status') === 'REGISTERED'
        ) {
          // not yet validated
          this.router.navigate(['register']);
        } else {
          // this.wsbFrontendService.getLoginStatus();
        }
      }
    });
  }

  processSubmenusHeight() {
    this.$navSidebarMenu.nativeElement.querySelectorAll('.nav-sidebar__submenu').forEach((element: HTMLElement) => {
      const elementHeight = element.scrollHeight;
      element.style.cssText = `max-height: ${elementHeight}px`;
    });
  }

  bindMenuItemsClick() {
    this.$navSidebarMenu.nativeElement.querySelectorAll('.nav-sidebar__item').forEach((menuItem: HTMLElement) => {
      menuItem.onclick = event => {
        if (!this.isSidebarFull) {
          this.toggleSidebar();

          const checkbox = menuItem.children.item(0);
          if (checkbox.classList.contains('nav-item__submenu-state')) {
            // @ts-ignore
            if (checkbox.checked) {
              event.preventDefault();
            }
          }
        }
      };
    });
  }

  toggleSidebar() {
    this.isSidebarFull = !this.isSidebarFull;
  }

  closeMobileNav() {
    this.document.body.classList.remove('has--nav-visible');
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
    this.domainSubscription.unsubscribe();
    this.menuEntriesSubscription.unsubscribe();
  }

  openRcp(): void {
    const brand = this.sessionStorage.retrieve('wsb-brand-name');
    if (brand === BrandName.MOBYT) {
      window.open(this.urlRcp, '_self');
    } else {
      this.router.navigate(['/studio']);
    }
  }

  displayNewStudioBadge() {
    const lang = 'ita';
    const brand = ['esendex', 'mobyt'];
    return (
      brand.includes(environment.brandName) &&
      !_.isUndefined(this.user) &&
      (this.user?.preferences?.language === lang || this.user?.nation === lang)
    );
  }

  personalizeStyle(domain: Domain): void {
    /**
     * As an alternative to using cssVars we update the existing css and replace the primary color
     */
    if ((window as any).loadedPersonalizedStyle) {
      return;
    }
    (window as any).loadedPersonalizedStyle = true;
    if (domain.style && domain.style.buttonColor) {
      const stylesheet = $('head link[rel="stylesheet"]');
      const stylesheetHref = stylesheet.last();
      if (stylesheetHref.length) {
        $.get(stylesheetHref.prop('href'), data => {
          const match = data.match(/--color-brand-primary-1:(.*?);/);
          let rules = data.replaceAll(match[1], domain.style.buttonColor);
          rules += `
      .btn-primary:hover {
        background-color: ${domain.style.buttonColor} !important;
      }
      .ag-layout-auto-height .ag-center-cols-clipper, .ag-layout-auto-height .ag-center-cols-container {
          /*min-height: 350px;*/
      }
    `;
          if (match && match[1]) {
            stylesheet.after($('<style>').append(rules));
            // stylesheet.attr('href', null).append(rules);
          }
        });
      }
    }
    if (domain.style && domain.style.titleColor) {
      const styleTitles = `
      body .page__title, h1, h2, h3 {
        color: ${domain.style.titleColor} !important;
      }
    `;
      $('<style>')
        .append(styleTitles)
        .appendTo('head');
    }
  }

  private checkApiMDelegation() {
    if (window.location.pathname !== '/api-m') {
      return;
    }
    // Receive requests of the form /?operation=SignIn&returnUrl={URL of source page}&salt={string}&sig={string}
    // Api M Delegation
    const operation = new URLSearchParams(window.location.search).get('operation');
    let returnUrl = new URLSearchParams(window.location.search).get('returnUrl');
    const sig = new URLSearchParams(window.location.search).get('sig');
    const salt = new URLSearchParams(window.location.search).get('salt');
    if (operation && sig && salt) {
      if (!returnUrl) {
        returnUrl = this.userService.getApiMDomain() + '/';
      }
      if (operation.toLowerCase() === 'signin') {
        this.sessionStorage.store('redirect-after-login-api-m-delegation', {
          returnUrl,
          sig,
          salt,
          operation
        });
        // return;
      } else if (operation.toLowerCase() === 'signout') {
        this.apiMDelegatedService.logout(salt, returnUrl, sig).subscribe(
          ret => {
            this.loginService.logout(false);
            this.loginService.clearAllCookies();
            // console.log('RETURNRUL logout', ret);

            let redirectUrl = returnUrl;
            const redirectUrlTmp = new URL(redirectUrl);
            redirectUrl = this.userService.getApiMDomain() + redirectUrlTmp.pathname + redirectUrlTmp.search;

            window.location.href = redirectUrl;
          },
          error => {
            window.location.href = '/';
          }
        );
        return;
      }
    }
    window.location.href = '/';
  }

  private checkReturnUrl() {
    // Check return url
    const returnUrlQueryParam = new URLSearchParams(window.location.search).get('return_url');
    const authcallbackUrlQueryParam = new URLSearchParams(window.location.search).get('auth_callback_url');
    if (returnUrlQueryParam && authcallbackUrlQueryParam) {
      this.sessionStorage.store('redirect-after-login', returnUrlQueryParam);
      this.sessionStorage.store('authcallback-after-login', authcallbackUrlQueryParam);
      this.loaderService.show();
      this.router.navigate(['/dashboard']);
    }
  }

  openRegistrationEmailModal(): void {
    if (this.user.profile.registrationEmail === null && this.modalRegistrationEmailModal == null) {
      this.modalRegistrationEmailModal = this.modalService.open(this.modalRegistrationEmail, { backdrop: 'static', keyboard: false });
      this.isRegistrationEmailModalOpen();
      this.modalRegistrationEmailModal.result.then(
        result => {
          if (this.router.url === '/') {
            this.router.navigate(['/dashboard']);
          }
        },
        reason => {}
      );
    }
  }

  modalRegistrationEmailForm(): void {
    this.profileService.addEmailRegistration(this.addEmailRegistration.value).subscribe(
      savedProfile => {
        this.atlasToastService.success('common_success', null, 6000, null);
        this.sessionStorage.store('wsb-routing-allowed', true);
        this.modalRegistrationEmailModal.close();
      },
      error => {
        if ((error.error as string).includes('already exists as a Login') || (error.error as string).includes('Duplicate entry')) {
          this.atlasToastService.error('email_already_exist_alert', null);
        } else {
          this.atlasToastService.error('common_error', null);
        }
      }
    );
  }

  isRegistrationEmailModalOpen() {
    this.modalRegistrationEmailModal.closed.subscribe(() => {
      this.addEmailRegistration.reset();
      this.repeatEmailRegistration.reset();
      this.modalRegistrationEmailModal = null;
    });
  }

  private openModalExpirePWD() {
    this.modalExpirePWDRef = this.modalService.open(this.modalExpirePWD, { backdrop: 'static' });
  }

  btnModalExpirePWD() {
    this.profileService.askAuth0ResetPassword(this.domain, this.user.profile.registrationEmail).subscribe(data => {
      if (data) {
        this.atlasToastService.notify('settings_account_changeemail_success', null, 2500, this.toastContainer);
        setTimeout(() => {
          this.loginService.destroySession();
          this.loginService.logout(true);
          this.loginService.clearAllCookies();
        }, 2500);
      }
    });
    return true;
  }

  canDeactivate(nextState: RouterStateSnapshot): Observable<boolean> | boolean {
    if (nextState.url === '/login') {
      this.modalRegistrationEmailModal.close();
      return true;
    }

    if (this.modalRegistrationEmailModal === null) {
      return true;
    }

    return false;
  }
}
